import { useState } from 'react';
import Header from '../components/Header';
import i18n from '../common/config/i18n';
import { ThemeSupa } from '@supabase/auth-ui-shared'
import { supabase } from '../common/config/supabase';
import { Auth } from '@supabase/auth-ui-react'

const customVariables = {
  default: {
    colors: {
      brand: '#60A5FA',
      brandAccent: '#1E3A8A',
    },
  },
};

const Landing = () => {
  const [, setSlidingMenuOpen] = useState<boolean>(false);


  return (
    <div>
      <Header openSlidingMenu={setSlidingMenuOpen}></Header>
      <div style={{ height: `calc(100vh - 4.5rem)` }} className="grid grid-cols-2">
        <div className="w-full flex justify-center items-center py-12 sm:px-6 lg:px-8 bg-landing bg-no-repeat bg-center bg-cover">
          <div className="bg-[#FFFFFF4D] flex flex-col items-center justify-center rounded-xl relative w-3/5 h-3/5 text-center text-white">
            <div className="items-center xl:items-start flex flex-col gap-4">
              <h1 className="text-3xl lg:text-6xl font-roboto font-bold">
                {i18n.t('login:frame_title')}
              </h1>
              <h3 className="text-lg lg:text-2xl font-roboto font-normal">
                {i18n.t('login:frame_description')}
              </h3>
            </div>
          </div>
        </div>
        <div className="pl-4 w-full flex flex-col justify-center items-center z-20">
          <div className="flex flex-col gap-14">
            <div className="justify-center flex flex-col items-start gap-[10px]">
              <h1 className="text-cool-gray-700 font-roboto text-3xl font-medium">
                {i18n.t('login:title')}
              </h1>
              <p className="font-roboto text-cool-gray-700 text-xl font-normal">
                {i18n.t('login:description')}
              </p>
            </div>
            <div className="flex flex-col gap-4">
              <Auth
                supabaseClient={supabase}
                appearance={{ theme: ThemeSupa, className: { container: 'w-[30rem]', }, variables: customVariables }}
                theme="light"
                providers={[]}
                view='magic_link'
                onlyThirdPartyProviders={false}
                showLinks={false}
                magicLink={true}
                redirectTo={'/'}
                localization={{
                  variables: {
                    magic_link: {
                      email_input_label: 'Adresa ta de email',
                      email_input_placeholder: 'Email-ul tau',
                      button_label: "Trimite Link-ul de autentificare",
                      loading_button_label: 'Trimitere...',
                      link_text: 'Link',
                      confirmation_text: 'Emailul cu link-ul de autentificare a fost trimis pe adresa ta de email',
                      empty_email_address: 'Adresa de Email trebuie completata.',
                    }
                  }
                }}
              />
              <small className="text-cool-gray-700 text-xs">{i18n.t('login:notice')}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Landing;
